export const DRAWING_MAX_FILES = 3;
export const DRAWING_MAX_FILE_BYTES = 10 * 1024 * 1024;
export const DRAWING_MAX_TOTAL_BYTES = 20 * 1024 * 1024;
export const DRAWING_ACCEPT = '.pdf,.dwg,.dxf,.zip';

/** Convenience checks are repeated authoritatively by the PHP receiver. */
export function drawingFilesError(files: ArrayLike<{ name: string; size: number }>): string | null {
  const items = Array.from(files);
  if (items.length > DRAWING_MAX_FILES) return 'Можно прикрепить не больше трёх файлов.';
  let total = 0;
  for (const file of items) {
    if (!/\.(pdf|dwg|dxf|zip)$/i.test(file.name) || /[\x00-\x1f\x7f]/.test(file.name)) {
      return 'Допустимы файлы PDF, DWG, DXF или ZIP.';
    }
    if (!Number.isSafeInteger(file.size) || file.size <= 0 || file.size > DRAWING_MAX_FILE_BYTES) {
      return 'Размер каждого файла должен быть от 1 байта до 10 МБ.';
    }
    total += file.size;
  }
  return total > DRAWING_MAX_TOTAL_BYTES ? 'Общий размер файлов не должен превышать 20 МБ.' : null;
}
